Ext.define('SA.lq.view.ResultsPanelHeader', {
    alias: 'widget.lq-results-panel-header',
    extend: 'Ext.Component',

    cls: 'sa-lq-view-results-panel-header',

    displayLoadingText() {
        this.update('Loading…');
    },

    displayResultCountText({count, geoUnit}) {
        var text = count === 1
            ? `1 ${geoUnit.getSingularName()} matches your location query`
            : `${SA.formatValue(count, '%d')} ${geoUnit.getPluralName()} match your location query`;

        this.update(text);
    }
});